import { ESettingsAliases } from 'settings';
import { ITax } from 'settings/interfaces';
import { EPaymentItemType } from 'types';

export const ENTITIES_ALIASES: Record<
  EPaymentItemType,
  { nds: ESettingsAliases; system: ESettingsAliases }
> = {
  GOOD: {
    nds: ESettingsAliases.GOODS_NDS,
    system: ESettingsAliases.GOODS_TAX_SYSTEM,
  },
  SERVICE: {
    nds: ESettingsAliases.SERVICES_NDS,
    system: ESettingsAliases.SERVICES_TAX_SYSTEM,
  },
  TARIFF: {
    nds: ESettingsAliases.TARIFFS_NDS,
    system: ESettingsAliases.TARIFFS_TAX_SYSTEM,
  },
  DEPOSIT: {
    nds: ESettingsAliases.DEPOSIT_NDS,
    system: ESettingsAliases.DEPOSIT_TAX_SYSTEM,
  },
  BONUS: {
    nds: ESettingsAliases.DEPOSIT_NDS,
    system: ESettingsAliases.DEPOSIT_TAX_SYSTEM,
  },
};

export const DEFAULT_TAXES_VALUE: ITax = {
  entities: null,
  taxVariant: null,
  nds: null,
};
